// =====================================================

import React, { useEffect, useState, Fragment, useMemo } from "react";
import styles from "./header.module.css";
import { Dialog, Transition, Listbox, Disclosure } from "@headlessui/react";
import logo from "../../images/EduUdr.svg";
import searchLogo from "../../images/search.svg";
import "react-dropdown/style.css";
import UploadPlaylist from "../../Components/Modals/UploadPlaylist";
import { GiSuitcase } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineArrowDropUp } from "react-icons/md";
import userprofile from "../../images/person.svg";
import log from "../../images/logout.svg";
import opp1 from "../../Assets/op1.jpg";
import opp2 from "../../Assets/op2.jpg";
import Logo from "../Logo/Logo";
import { useTheme } from "../../Context/ThemeContext";
import {
  Sun,
  Moon,
  User,
  LayoutDashboard,
  Settings,
  LogOut,
} from "lucide-react";
import { useData } from "../../Context/DataContext";
import {
  isAuthenticated,
  logout,
  getUser,
} from "../../helper/authApiCalls/auth";
import { getBranchedCategories } from "../../helper/categoryApiCalls/category";
import Payment from "../../helper2/payment";
import menu from "../../images/menu.svg";
import close from "../../images/close.svg";
import back from "../../images/back.svg";
import { CreateOpportunity } from "../../helper/opportunity";
import { toast, ToastContainer } from "react-toastify";
import UploadVideos from "../../Components/Modals/UploadVideos";
import UploadPlaylistModal from "../../Components/Modals/UploadPlaylist";

const people = [
  { name: "Full Time" },
  { name: "Part Time" },
  { name: "Internship" },
  { name: "Work From Home" },
];

const DropDownRow = ({
  itemname,
  list = [],
  categories,
  catId,
  closeDropdown,
  onSelect,
}) => {
  const handleSelect = () => {
    if (onSelect) onSelect(itemname);
    if (closeDropdown) closeDropdown();
  };

  return (
    <li className={styles.dropdownRow}>
      <Link to={"/category/" + catId} onClick={handleSelect}>
        <button className="w-full text-left flex items-center outline-none focus:outline-none">
          <span className="pr-1 flex-1 text-sm">{itemname}</span>
          {list.length > 0 && (
            <span className="mr-auto">
              <svg
                className="fill-current h-4 w-4 transition duration-150 ease-in-out"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </span>
          )}
        </button>
      </Link>

      {list.length > 0 && (
        <ul className={styles.nestedDropdown}>
          {list.map((sub) => {
            const subList =
              categories?.level2?.find((x) => x._id === sub._id)
                ?.subCategories || [];
            return (
              <DropDownRow
                key={sub._id}
                categories={categories}
                itemname={sub.name}
                catId={sub._id}
                list={subList}
                closeDropdown={closeDropdown}
                onSelect={onSelect}
              />
            );
          })}
        </ul>
      )}
    </li>
  );
};

const DisclosureDrop = ({ itemname, list = [], categories, catId }) => {
  return list.length > 0 ? (
    <Disclosure as="div" className="mt-2">
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full justify-between rounded-lg bg-gray-100 px-4 py-2 text-left text-sm font-medium text-purple-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2">
            <Link to={"/category/" + catId}>
              <span className="font-[600]">{itemname}</span>
            </Link>
            <MdOutlineArrowDropUp
              className={`${open ? "rotate-180 transform" : ""} h-5 w-5`}
            />
          </Disclosure.Button>
          <Disclosure.Panel className="px-4 pt-2 pb-2 text-sm text-gray-500">
            {list.map((sub) => {
              const subList =
                categories?.level2?.find((x) => x._id === sub._id)
                  ?.subCategories || [];
              return (
                <DisclosureDrop
                  key={sub._id}
                  categories={categories}
                  itemname={sub.name}
                  catId={sub._id}
                  list={subList}
                />
              );
            })}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  ) : (
    <Link to={"/category/" + catId}>
      <div className="rounded-sm cursor-pointer px-3 py-1 hover:bg-gray-900">
        {itemname}
      </div>
    </Link>
  );
};

function Header() {
  const { theme, toggleTheme } = useTheme();

  const [openVideoUploadingModal, setOpenVideoUploadingModal] = useState(false);
  const [openPlaylistUploadingModal, setOpenPlaylistUploadingModal] =
    useState(false);
  const [open, setOpen] = useState(false);
  const [don, setDon] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showbackground, setShowbackground] = useState(false);
  const [searchkey, setSearchkey] = useState("");
  const [user, setUser] = useState({});
  const [busy, setBusy] = useState(true);
  const navigate = useNavigate();
  const [menuopen, setMenuopen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [selected, setSelected] = useState(people[0]);
  const [selectedCategoryLabel, setSelectedCategoryLabel] =
    useState("Categories");
  const [opportunity, setOpportunity] = useState({
    comapanyName: "",
    email: "",
    phone: "",
    jobTitle: "",
    jobType: "",
    jobDescription: "",
    jobLocation: "",
    question: "",
  });
  let [isOpen2, setIsOpen2] = useState(false);

  async function submitOpp() {
    const body = {
      ...opportunity,
      jobType: selected.name,
    };
    const res = await CreateOpportunity(body);
    if (res.success) {
      toast.success("Opportunity Created Successfully");
      setTimeout(() => window.location.reload(false), 2500);
    } else if (res.error) {
      console.log(res.error);
    }
  }

  const handleOpportunity = (e) => {
    setOpportunity({ ...opportunity, [e.target.name]: e.target.value });
  };

  function fetchCategories() {
    getBranchedCategories().then((data) => {
      if (!data?.error) {
        setCategories(data?.data);
        setBusy(false);
      }
    });
  }

  function closeModal2() {
    setIsOpen2(false);
  }
  function openModal2() {
    setIsOpen2(true);
  }

  useEffect(() => {
    fetchCategories();
    if (localStorage.getItem("_access_token")) {
      getUser().then((data) => {
        if (data) setUser(data.data);
        else localStorage.removeItem("_access_token");
      });
    }
  }, []);

  const handleSearch = () => {
    if (searchkey.trim() !== "") navigate(`/search/${searchkey}`);
  };

  const { titles } = useData();

  const [showSuggestions, setShowSuggestions] = useState(false);

  // Filter playlists based on input
  const suggestions = useMemo(() => {
    if (!searchkey) return [];

    return (titles || [])
      .filter((title) => title?.toLowerCase().includes(searchkey.toLowerCase()))
      .slice(0, 8); // limit to 8 suggestions
  }, [searchkey, titles]);

  const handleSelect = (title) => {
    setSearchkey(title);
    setShowSuggestions(false);
    navigate(`/search/${title}`);
  };

  // Inline CategoryDropdown logic
  const CategoryDropdown = !busy && (
    <div className="group inline-block relative">
      <button className={styles.categoryButton}>
        <span className="pr-1 font-[400] flex-1">{selectedCategoryLabel}</span>
        <span>
          <svg
            className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </span>
      </button>
      <ul className={styles.categoryDropdown}>
        {categories?.categories?.map((item) => (
          <DropDownRow
            key={item._id}
            categories={categories}
            catId={item._id}
            itemname={item.name}
            list={item.subCategories?.length > 0 ? item.subCategories : []}
            closeDropdown={() => setShowbackground(false)}
            onSelect={setSelectedCategoryLabel}
          />
        ))}
      </ul>
    </div>
  );

  const checkClass = menuopen ? styles.show : "";

  return (
    <>
      {/* HeaderBar */}
      <header className={styles.container}>
        <div>
          <Link to="/">
            <Logo />
          </Link>
        </div>
        {showbackground && <div className={styles.blockback}></div>}
        <div
          onMouseEnter={() => !busy && setShowbackground(true)}
          onMouseLeave={() => setShowbackground(false)}
        >
          <ul>{CategoryDropdown}</ul>
          <div className={styles.strip}></div>
          <div className={styles.blockmodal}>
            <div className={styles.blockleft}></div>
          </div>
        </div>

        <div className={styles.searchContainer}>
          <input
            type="text"
            className={styles.input}
            value={searchkey}
            onChange={(e) => {
              setSearchkey(e.target.value);
              setShowSuggestions(true);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
                setShowSuggestions(false);
              }
            }}
            placeholder="Search any category or playlist"
          />

          <img
            src={searchLogo}
            alt="searchLogo"
            className={styles.logo}
            onClick={handleSearch}
          />

          {showSuggestions && suggestions.length > 0 && (
            <div className={styles.suggestionBox}>
              {suggestions.map((item, index) => (
                <div
                  key={index}
                  className={styles.suggestionItem}
                  onClick={() => handleSelect(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>

        <div
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={toggleTheme}
        >
          {theme === "light" ? (
            <Moon size={24} color="#000" />
          ) : (
            <Sun size={24} color="#fff" />
          )}
        </div>

        {/* Auth Section */}
        <div className={`${styles.creds}`}>
          {!isAuthenticated() && (
            <div className="flex items-center space-x-2">
              <Link to="/signin" className={styles.link}>
                <p className={styles.login}>Log in</p>
              </Link>
              <Link to="/signup" className={styles.link}>
                <p className={styles.login}>Sign up</p>
              </Link>
              <a
                target={"_blank"}
                rel="noreferrer"
                href="https://chat.whatsapp.com/LmHbabqhQOi498mWqW1X3s"
                className={styles.link}
              >
                <p className={styles.login}>Join our community</p>
              </a>
            </div>
          )}
          {isAuthenticated() && (
            <div className={styles.userblock}>
              <div className={styles.name}>
                {user?.profileimage ? (
                  <img
                    src={user.profileimage}
                    alt=""
                    className={styles.userAvatar}
                  />
                ) : (
                  <User size={20} style={{ marginRight: "8px" }} />
                )}
                {user?.name}
              </div>
              <div className={styles.userlist}>
                {user.role === "creator" && (
                  <div className={styles.droppeduserlist}>
                    <ul>
                      <Link to="/dash">
                        <li>
                          <div className={styles.icon_box}>
                            <LayoutDashboard size={20} />
                          </div>
                          My Dashboard
                        </li>
                      </Link>
                      <Link to="/settings">
                        <li>
                          <div className={styles.icon_box}>
                            <Settings size={20} />
                          </div>
                          Settings
                        </li>
                      </Link>
                      <li
                        onClick={() => {
                          logout().then(() => window.location.reload(false));
                        }}
                      >
                        <div className={styles.icon_box}>
                          <LogOut size={20} />
                        </div>
                        Logout
                      </li>
                    </ul>
                  </div>
                )}
                {user.role === "user" && (
                  <div className={styles.droppeduserlist}>
                    <ul>
                      <Link to="/profile">
                        <li>
                          <div className={styles.icon_box}>
                            <User size={20} />
                          </div>
                          My Profile
                        </li>
                      </Link>
                      <li
                        onClick={() => {
                          logout().then(() => window.location.reload(false));
                        }}
                      >
                        <div className={styles.icon_box}>
                          <LogOut size={20} />
                        </div>
                        Logout
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {isAuthenticated() && user.role === "user" && (
          <Link to="/playlists">
            <p
              className={styles.signup}
              style={{ borderColor: theme === "dark" ? "white" : "black" }}
            >
              Explore
            </p>
          </Link>
        )}
        {isAuthenticated() && user.role === "creator" && (
          <p
            className={styles.signup}
            onClick={() => setOpenVideoUploadingModal((val) => !val)}
          >
            Upload Videos
          </p>
        )}

        {isAuthenticated() && user.role === "creator" && (
          <p
            className={styles.signup}
            onClick={() => setOpenPlaylistUploadingModal((val) => !val)}
          >
            Upload Playlist
          </p>
        )}

        {open && <UploadPlaylist open={open} setOpen={setOpen} />}
        {openVideoUploadingModal && (
          <UploadVideos
            open={openVideoUploadingModal}
            setOpen={setOpenVideoUploadingModal}
          />
        )}
        {openPlaylistUploadingModal && (
          <UploadPlaylistModal
            open={openPlaylistUploadingModal}
            setOpen={setOpenPlaylistUploadingModal}
          />
        )}
        {don && <Payment don={don} setDon={setDon} />}

        {/* OppPopup */}
        <Transition appear show={isOpen2} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal2}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>
            <div className="fixed inset-0  w-full overflow-y-auto ">
              <div className="flex min-h-full w-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  {/* Dialog Panel was commented out in original code */}
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </header>

      {/* Header Mobile */}
      <div className={styles.headermobile}>
        <div className={styles.menu} onClick={() => setMenuopen(true)}>
          <img
            src={menu}
            alt="menu"
            style={{ filter: theme === "dark" ? "invert(1)" : "none" }}
          />
        </div>
        {!menuopen && (
          <div className={styles.mobileThemeToggle} onClick={toggleTheme}>
            {theme === "light" ? (
              <Moon size={24} />
            ) : (
              <Sun size={24} color="#fff" />
            )}
          </div>
        )}
        <div className={styles.backbtn} onClick={() => navigate(-1)}>
          <img
            src={back}
            alt="back"
            style={{ filter: theme === "dark" ? "invert(1)" : "none" }}
          />
        </div>

        <div className={styles.logocontainer}>
          <Link to="/">
            <Logo />
          </Link>
        </div>

        <div className={`${styles.menublock} ${checkClass}`}>
          <div className={styles.topblock}>
            <div className={styles.menu} onClick={() => setMenuopen(false)}>
              <img
                src={close}
                alt="close"
                style={{ filter: theme === "dark" ? "invert(1)" : "none" }}
              />
            </div>
            <div className={styles.logocontainer}>
              <Logo />
            </div>
          </div>
          <div className={styles.middleblock}>
            <p className="font-bold mb-3">Categories</p>
            {categories?.categories?.map((item) => (
              <DisclosureDrop
                key={item._id}
                categories={categories}
                catId={item._id}
                itemname={item.name}
                list={item.subCategories?.length > 0 ? item.subCategories : []}
              />
            ))}
            <a
              href="https://chat.whatsapp.com/LmHbabqhQOi498mWqW1X3s"
              target="_blank"
              rel="noreferrer"
              onClick={() => setMenuopen(false)}
            >
              <p className="mt-3 text-lg font-semibold">Join our community</p>
            </a>
            {isAuthenticated() && user.role === "user" && (
              <Link to="/playlists" onClick={() => setMenuopen(false)}>
                <p className="mt-3 text-lg font-semibold">Explore</p>
              </Link>
            )}
            <div className="mt-6 border-t pt-4">
              {!isAuthenticated() ? (
                <>
                  <Link to="/signin" onClick={() => setMenuopen(false)}>
                    <p className="mt-3 text-lg font-semibold text-blue-600">
                      Log in
                    </p>
                  </Link>
                  <Link to="/signup" onClick={() => setMenuopen(false)}>
                    <p className="mt-2 text-lg font-semibold text-blue-600">
                      Sign up
                    </p>
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/profile" onClick={() => setMenuopen(false)}>
                    <div className="flex items-center mt-3">
                      {user?.profileimage ? (
                        <img
                          src={user.profileimage}
                          alt=""
                          className={styles.userAvatar}
                          style={{ width: "24px", height: "24px" }}
                        />
                      ) : (
                        <User size={18} style={{ marginRight: "8px" }} />
                      )}
                      <p className="text-sm text-gray-500 cursor-pointer hover:underline">
                        {user?.name}
                      </p>
                    </div>
                  </Link>
                  <p
                    role="button"
                    tabIndex={0}
                    className="mt-2 text-lg font-semibold text-red-600 cursor-pointer"
                    onClick={() => {
                      logout().then(() => {
                        setMenuopen(false);
                        window.location.reload(false);
                      });
                    }}
                  >
                    Logout
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Header;
